angular.module('app')
	.controller('UploadCtrl', function ($scope, $rootScope, $http, $location, $cookieStore, $filter, HttpService, FileUploader, $timeout, $download) {

		$scope.listafile = [];
		$scope.load = false;
		$scope.files;
		$scope.mergedFileName;
		$scope.folderPath;
		$scope.filesNames = [];
		$scope.uploadCompleted = false;
		$scope.uploading = false;
		$scope.partitaIva = '';
		$scope.reloadPage = function () {
			location.reload();
		}

		$scope.uploader = new FileUploader({
			url: '',
			headers: {
				'Access-Control-Allow-Origin': '*',
				'Authorization': 'Bearer ' + ($configService.getAppConfig().token || 'no-token')
			}
		});

		$scope.removeSelectedItem = function (fileItem) {
			fileItem.remove();
			var tempFilesNames = [];
			for (var int = 0; int < $scope.filesNames.length; int++) {
				if ($scope.filesNames[int] != fileItem.file.name) {
					tempFilesNames.push($scope.filesNames[int]);
				}
			}
			$scope.filesNames = tempFilesNames;
		}




		$scope.clearQueue = function () {
			$scope.filesNames = [];
			$scope.uploader.clearQueue();
		}

		$scope.finalUpload = function () {
			$scope.folderPath = '' + new Date().getTime();
			var url = $configService.getAppConfig().url + '/fileService/upload/' + encodeURIComponent($scope.partitaIva) + '/'
			for (var int = 0; int < $scope.uploader.queue.length; int++) {
				$scope.uploader.queue[int].url = url;
			}
			$scope.uploading = true;
			$scope.uploader.uploadAll();

		}

		$scope.uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
			console.info('onWhenAddingFileFailed', item, filter, options);
		};





		$scope.uploader.onAfterAddingFile = function (fileItem) {
			if (fileItem.file.size > 26214400) {
				$rootScope.$broadcast('addAlert', { text: 'MAXIMUM_FILE_SIZE_EXCEEDED' });
				fileItem.remove();
				return;
			}
			var fileName = fileItem.file.name;
			if (fileName.toLowerCase().indexOf('.pdf') > -1 || fileName.toLowerCase().indexOf('.png') > -1 || fileName.toLowerCase().indexOf('.jpg') > -1 || fileName.toLowerCase().indexOf('.jpeg') > -1) {
				fileItem.file.name = $scope.formatAllegatoName(fileName);
			} else {
				fileItem.remove();
				$scope.errorUploadTypeFile();
			}
			//console.info('onAfterAddingFile', fileItem);
		};
		$scope.formatAllegatoName = function (fileName) {
			try {
				var cleanedFileName = fileName.substring(0, fileName.length - 4);
				for (var allIdx = 0; allIdx < $scope.filesNames.length; allIdx++) {
					if ($scope.filesNames[allIdx].indexOf(cleanedFileName) > -1) {
						var copyNumbers = $scope.getFileNameCopyNumbers(cleanedFileName);
						var finalNameVal = cleanedFileName + " (" + copyNumbers + ")";
						$scope.filesNames.push(finalNameVal);
						console.log(finalNameVal1);
						return finalNameVal;
					}
				}
				$scope.filesNames.push(fileName);
				return fileName;
			} catch (e) {
				console.log(e.name + ': ' + e.message);
				return fileName;
			}
		}

		$scope.uploader.onAfterAddingAll = function (addedFileItems) {
			console.info('onAfterAddingAll', addedFileItems);

		};

		$scope.uploader.onBeforeUploadItem = function (item) {
			console.log(item);
			item.file.name = window.encodeURIComponent(item.file.name);


			item.headers['Authorization'] = 'Bearer ' + $configService.getAppConfig().token;
		};

		$scope.uploader.onProgressItem = function (fileItem, progress) {
			//console.info('onProgressItem', fileItem, progress);
		};

		$scope.uploader.onProgressAll = function (progress) {
			//console.info('onProgressAll', progress);
		};

		$scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
			//console.info('onSuccessItem', fileItem, response, status, headers);
		};

		$scope.uploader.onErrorItem = function (fileItem, response, status, headers) {
			console.info('onErrorItem', fileItem, response, status, headers);
			$rootScope.$broadcast('addAlert', { text: 'ERROR_UPLOADING_FILE' });
			fileItem.remove();
		};

		$scope.uploader.onCancelItem = function (fileItem, response, status, headers) {
			//console.info('onCancelItem', fileItem, response, status, headers);
		};

		$scope.uploader.onCompleteItem = function (fileItem, response, status, headers) {
			console.info('onCompleteItem', fileItem, response, status, headers);
			$configService.getAppConfig().token = headers['x-refresh-token'];
		};

		$scope.uploader.onCompleteAll = function () {
			console.info('onCompleteAll');
			$scope.uploadCompleted = true;
			$scope.uploading = false;
		};

		$scope.sendEmail = function () {
			console.log(input = { folderPath: $scope.partitaIva, fileName: $scope.filesNames[0] })
			HttpService.send('/fileService/sendEmail', input = { folderPath: $scope.partitaIva, fileName: $scope.filesNames[0] })
		}
		$scope.path = '';

		$scope.getAllFile = function () {
			console.log($scope.path);
			HttpService.send('/fileService/getAll', $scope.path).then(function (response) {
				if (response.success) {
					console.log(response);

					$scope.load = true;
					$scope.listafile = response.listaFile;
				}
			});

		}

		$scope.deleteFile = function (file, $index) {
			$scope.completeFile = $scope.path + "/" + file;
			HttpService.send('/fileService/deleteFile', $scope.completeFile).then(function (response) {
				if (response.success) {
					console.log(response, "madonna");
					$scope.getAllFile();
				}
			});

		}

	})